import { useTranslation } from "react-i18next"

import { Card, CardContent } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"

/**
 * OKS-64 — Empty-state card for `oauth_state === "active"` +
 * `snapshot_count === 0`. Shown right after a creator connects
 * TikTok but before the next daily-04:00-UTC poll runs.
 *
 * Per UX Spec §3: heading + body copy + subtle Skeleton ribbon to
 * imply pending data. Skeleton matches the populated layout's
 * chart skeleton dimensions so the visual swap on first snapshot
 * arrival doesn't reflow.
 */
export function CreatorAnalyticsSyncingCard() {
  const { t } = useTranslation()

  return (
    <Card data-testid="creator-analytics-timeseries-syncing">
      <CardContent className="flex flex-col gap-4 py-8">
        <div className="flex flex-col items-center gap-2 text-center">
          <h3 className="text-base font-medium">
            {t("crew.analytics.timeseries.syncing.title")}
          </h3>
          <p className="text-muted-foreground max-w-md text-sm">
            {t("crew.analytics.timeseries.syncing.body")}
          </p>
        </div>
        <Skeleton className="h-32 w-full" />
      </CardContent>
    </Card>
  )
}

export default CreatorAnalyticsSyncingCard
